<template>
	<div class="chip-button" :class="{ active, 'no-borders': noBorders }">
		<slot />
	</div>
</template>

<script setup lang="ts">
defineProps<{ active?: boolean; noBorders?: boolean }>();
</script>

<style lang="scss">
@import '~@/styles/variables.scss';

.chip-button {
	white-space: nowrap;
	border: 1px solid transparent;
	border-radius: 4px;
	background-color: transparent;
	transition: background-color 0.1s linear;
	display: flex;
	align-items: center;

	button {
		border: none;
		background: none;
	}

	&.no-borders {
		border: 0;
	}

	a,
	button {
		display: block;
		font-weight: 400;
		font-size: 15px;
		padding: 5px 10px;
		color: $jw-color-lightgray--dark;
		text-overflow: ellipsis;
		overflow: hidden;
		cursor: pointer;
	}

	&.active {
		background-color: $jw-color-mediumblue--dark;
		color: white;

		a,
		button {
			color: white;
		}
	}

	&:last-child {
		border-inline-end-width: 1px;
		margin-inline-end: 0;
	}
}
</style>
